module.exports = __webpack_public_path__ + "static/concierge-hero-331fc28454a2cf0862fca9ee5e98ad11.jpg";